/* T8 Spaces Coverflow: centre card enlarged, neighbours smaller; click a side card / prev / next / dot / arrow keys / swipe to re-centre.
   Positions are written as data-pos="-2|-1|0|1|2|hidden" on each item; CSS does the sizing and movement. */
(function () {
  'use strict';

  function init(root) {
    (root || document).querySelectorAll('[data-t8-cf]').forEach(function (cf) {
      if (cf.dataset.ready) return; cf.dataset.ready = '1';
      var track = cf.querySelector('[data-t8-cf-track]');
      var items = Array.prototype.slice.call(cf.querySelectorAll('[data-t8-cf-item]'));
      var dotsEl = cf.querySelector('[data-t8-cf-dots]');
      var n = items.length;
      if (!track || !n) return;
      var active = Math.min(Math.max(parseInt(cf.dataset.start || '0', 10) || 0, 0), n - 1);
      var dots = [];
      var prev = cf.querySelector('[data-t8-cf-prev]');
      var next = cf.querySelector('[data-t8-cf-next]');
      var loop = cf.dataset.loop !== 'false';   // data-loop="false" (frames on the buying guide): no wrap, the first card opens with nothing on its left

      function offsetFor(i) {
        // circular distance so the rail wraps (only when there are enough cards to fill 5 slots)
        var d = i - active;
        if (loop && n >= 5) { if (d > n / 2) d -= n; if (d < -n / 2) d += n; }
        return d;
      }

      function render() {
        items.forEach(function (it, i) {
          var d = offsetFor(i);
          var pos = Math.abs(d) <= 2 ? String(d) : (d > 0 ? '3' : '-3');   // off-stage: waiting on the right / gone to the left
          var was = it.getAttribute('data-pos');
          if (was && Math.abs((parseInt(was, 10) || 0) - (parseInt(pos, 10) || 0)) > 3) {   // wrap-around (left → right): jump, don't slide across
            it.classList.add('is-jump'); it.setAttribute('data-pos', pos); void it.offsetWidth; it.classList.remove('is-jump');
          }
          it.setAttribute('data-pos', pos);
          var card = it.querySelector('[data-t8-cf-card]');
          if (card) {
            card.setAttribute('aria-current', d === 0 ? 'true' : 'false');
            card.tabIndex = Math.abs(d) > 2 ? -1 : 0;
          }
        });
        if (!loop) { if (prev) prev.disabled = active === 0; if (next) next.disabled = active === n - 1; }
        dots.forEach(function (b, i) {
          b.classList.toggle('is-active', i === active);
          b.setAttribute('aria-selected', i === active ? 'true' : 'false');
        });
      }

      function go(i) { active = loop ? ((i % n) + n) % n : Math.max(0, Math.min(n - 1, i)); render(); }

      // dots
      if (dotsEl) {
        dotsEl.innerHTML = '';
        items.forEach(function (it, i) {
          var b = document.createElement('button');
          b.type = 'button'; b.setAttribute('role', 'tab');
          var label = it.querySelector('.t8-cf__label');
          b.setAttribute('aria-label', 'Show ' + (label ? label.textContent.trim() : 'card ' + (i + 1)));
          b.addEventListener('click', function () { go(i); });
          dotsEl.appendChild(b); dots.push(b);
        });
      }

      // side cards: click re-centres instead of navigating; centre card follows its link
      items.forEach(function (it, i) {
        var card = it.querySelector('[data-t8-cf-card]');
        if (!card) return;
        var wasCentre = false;   // centre when the finger / mouse went down (auto-advance can move it before the click lands)
        card.addEventListener('pointerdown', function () { wasCentre = i === active; });
        card.addEventListener('click', function (e) {
          if (i !== active && !wasCentre) { e.preventDefault(); go(i); }
          else if (card.getAttribute('href') === '#') e.preventDefault();
        });
        card.addEventListener('focus', function () { if (i !== active) go(i); });
      });

      if (prev) prev.addEventListener('click', function () { go(active - 1); });
      if (next) next.addEventListener('click', function () { go(active + 1); });

      // keyboard
      cf.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') { e.preventDefault(); go(active - 1); }
        else if (e.key === 'ArrowRight') { e.preventDefault(); go(active + 1); }
      });

      // touch / pointer swipe
      var startX = null, startY = null, moved = false;
      track.addEventListener('pointerdown', function (e) { startX = e.clientX; startY = e.clientY; moved = false; });
      track.addEventListener('pointermove', function (e) {
        if (startX === null) return;
        if (Math.abs(e.clientX - startX) > 10 && Math.abs(e.clientX - startX) > Math.abs(e.clientY - startY)) moved = true;
      });
      function end(e) {
        if (startX === null) return;
        var dx = e.clientX - startX; startX = null;
        if (moved && Math.abs(dx) > 40) { go(dx < 0 ? active + 1 : active - 1); suppressClick = true; setTimeout(function () { suppressClick = false; }, 300); }
      }
      var suppressClick = false;
      track.addEventListener('pointerup', end);
      track.addEventListener('pointercancel', function () { startX = null; });
      track.addEventListener('click', function (e) { if (suppressClick) { e.preventDefault(); e.stopPropagation(); } }, true);

      // autoplay: advance right → left every N seconds; pause while hovered, focused or off-screen; off for reduced motion
      var secs = parseFloat(cf.dataset.autoplay || '0');
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (secs > 0 && !reduce && n > 1) {
        var hover = false, inView = true, timer = null;
        function tick() { if (!hover && inView && !document.hidden) go(!loop && active === n - 1 ? 0 : active + 1); }   // no-loop: back to the first card after the last
        function start() { clearInterval(timer); timer = setInterval(tick, secs * 1000); }
        cf.addEventListener('mouseenter', function () { hover = true; });
        cf.addEventListener('mouseleave', function () { hover = false; });
        cf.addEventListener('focusin', function () { hover = true; });
        cf.addEventListener('focusout', function () { hover = false; });
        ['click', 'keydown', 'pointerup'].forEach(function (ev) { cf.addEventListener(ev, start); });   // manual move restarts the countdown
        if ('IntersectionObserver' in window) new IntersectionObserver(function (en) { inView = en[0].isIntersecting; }).observe(cf);
        start();
      }

      render();
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); }); else init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
